import { ForgotPasswordForm } from "@container/forgot-password-form";
import BasicLayout from "@container/layout/basic";


export default function ForgotPasswordPage() {
    return (
        <BasicLayout showFooter={false}>
            <div className="w-full max-w-md mx-auto px-4 md:px-0">
                <ForgotPasswordForm />
            </div>
        </BasicLayout>
    );
}
